<template>
  <div class="mb-[24px]">
    <div class="border border-[#E2E2E2] rounded-[12px] p-[12px]">
      <h4
        v-if="marketplaceLabel"
        class="text-[#828282] text-[14px] font-[400] mb-[12px]"
      >
        {{ marketplaceLabel }}
      </h4>
      <p class="text-[#333333] font-[500] mb-[1px]">
        {{ marketplace.name }}
      </p>
      <p class="text-[#626262] text-[12px] mb-0">
        SKU: {{ marketplace.sku || '-' }}
      </p>
    </div>

    <div
      v-if="isSynced"
      class="bg-[#DCF3EB] rounded-[12px] p-[12px] mt-[12px] flex justify-between items-start flex-wrap gap-[12px]"
    >
      <div>
        <h4 class="text-[#34A770] text-[14px] font-[400] mb-[12px]">
          Terhubung dengan:
        </h4>
        <p class="text-[#10673E] font-[500] mb-[1px]">
          {{ kompack.name }}
        </p>
        <p class="text-[#34A770] text-[12px] mb-0">
          SKU: {{ kompack.sku || '-' }}
        </p>
      </div>
      <div>
        <b-button
          variant="danger"
          class="w-full [&.btn-danger]:!bg-[#E31A1A] !flex items-center justify-center gap-[8px]"
          :disabled="isDisconnecting"
          @click="handleDisconnect"
        >
          <b-spinner
            v-if="isDisconnecting"
            small
            variant="white"
          />
          Putuskan
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MappingInfoCard',

  props: {
    isDisconnecting: {
      type: Boolean,
      default: false,
    },
    marketplace: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        sku: '',
      }),
    },
    kompack: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        sku: '',
      }),
    },
    isSynced: {
      type: Boolean,
      default: false,
    },
    marketplaceLabel: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleDisconnect() {
      this.$emit('disconnect')
    },
  },
}
</script>
